/**
 * Content section layout types — used by homepage rendering engine (future).
 * Do not hardcode homepage layout logic in admin forms.
 */
export const SECTION_LAYOUT_OPTIONS = [
  { value: "Grid", label: "Grid" },
  { value: "Slider", label: "Slider" },
  { value: "Featured", label: "Featured" },
  { value: "Sidebar", label: "Sidebar" },
  { value: "Editorial", label: "Editorial" },
  { value: "Cards", label: "Cards" },
];
